import { render, staticRenderFns } from "./dentalMachineRecord.vue?vue&type=template&id=36b733c8&scoped=true&"
import script from "./dentalMachineRecord.vue?vue&type=script&lang=js&"
export * from "./dentalMachineRecord.vue?vue&type=script&lang=js&"
import style0 from "./dentalMachineRecord.vue?vue&type=style&index=0&id=36b733c8&scoped=true&lang=css&"
import style1 from "./dentalMachineRecord.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b733c8",
  null
  
)

export default component.exports